import React from 'react';

const T = { bg: '#f0f5e8', cream: '#fffef0', greenDk: '#1b5e20', maroon: '#6d1b1b', border: '#c8e6c9', header: 'linear-gradient(135deg, #090b72, #1a237e)' };

const DayDhoshaPage = () => {
  return (
    <div style={{ padding: '15px', background: T.bg, minHeight: '100vh', fontFamily: 'sans-serif', lineHeight: 1.6 }}>
      <div style={{ background: T.header, padding: '12px', borderRadius: '10px', textAlign: 'center', marginBottom: '15px' }}>
        <h1 style={{ color: '#fff', margin: 0, fontSize: '1.2rem', fontWeight: 900 }}>அறிமுகம்</h1>
      </div>
      <div dangerouslySetInnerHTML={{ __html: `



  <h1>நாளின் 21 வித தோஷங்கள்</h1>
  <div class="accordion">
  <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
    <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;">
  <div class="head3">குறிப்புரை </div>        
</summary>
  <div class="div2">
    குறிப்பு:-  நாட்களும், நேரங்களும் 21 வித தோஷங்களில் 
  ஏதாவது சில பலவற்றால் பாதிப்புடனே இருக்கும் . 
  எந்தவித தோஷமுமில்லாத முஹூர்த்தத்தை ப்ரஹ்மாவால் 
  கூட கண்டறிந்து குறிக்க முடியாது என பெரியோர் கூறுவர்.
  பஞ்சாங்கங்களில் சில முக்கியமான தோஷங்களை மட்டுமே
   விலக்கி முஹூர்த்தங்கள் கொடுத்திருப்பார்கள்.  ஆயினும்
    எல்லாவித தோஷங்களைப் பற்றியும் தெரிந்து வைத்திருப்பது நல்லது. 
     எனவே சுபங்களில் மந்திரங்களில்
  அலக்ஷியம் காட்டாமல் சிரத்தையாக கர்மாக்களைப் பண்ணினால் 
  பலவித தோஷங்கள் பரிஹாரம் பெற்று சிறந்த பலனைப் பெறலாம்.
  </div>
  </details>
  
    <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
          <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">1. உல்கா </div>         </summary>
    <div class="mydiv"> 
              
     
  சூரியன் நின்ற நட்சத்திரத்திலிருந்து 19வது நக்ஷத்திரம் உல்கா அல்லது உலக நக்ஷத்திரம் என்று சொல்லப்படும். இந்த நக்ஷத்திரத்தில் முஹூர்த்தம் வைக்கக்கூடாது.
  
      
          </div>  
          
          </details><details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
          <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">2. பூகம்பம் </div>         </summary>
    <div class="mydiv">
               
     
  சூரியன் நின்ற நக்ஷத்திரத்திலிருந்து ஒன்பதாவது நக்ஷத்திரம் பூகம்ப நக்ஷத்திரம் ஆகும்.  இது முஹூர்த்த்திற்கு ஆகாது.
      
          </div></details>
   <details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
          <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">3. உபாகம் </div>         </summary>
    <div class="mydiv">
               
      
  சூரிய கிரஹணம் அல்லது சந்திர கிரஹணம் ஏற்படும் நாளும் அதற்கு முன் 3 நாட்களும், பின் 3 நாட்களும் உபாகம் எனும் முஹூர்த்திற்கு ஆகாத நாட்களாகும்.
      
          </div>
    
  
    </details><details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
          <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">4. குளிகன் (அ) மாந்தி </div>         </summary>
    <div class="mydiv"> 
              
      
  ஒவ்வொரு நாளிலும் குளிகன் அல்லது மாந்தி உதயமாகும் நேரத்திற்குரிய லக்னத்தில் முஹூர்த்தம் வைக்கக்கூடாது.
  மாந்தி உதயமாகும் நாழிகைகள்<hr>
  
       <tr style="border-bottom:1px solid #ccc">
       <td style="padding:8px; border:1px solid #e0e0e0">கிழ</td>
       <td style="padding:8px; border:1px solid #e0e0e0">பகல்</td>
       <td style="padding:8px; border:1px solid #e0e0e0">இரவு</td>
       
       </tr>
      
      <tr style="border-bottom:1px solid #ccc">
       <td style="padding:8px; border:1px solid #e0e0e0">ஞா
       </td>
       <td style="padding:8px; border:1px solid #e0e0e0">26
       </td>
       <td style="padding:8px; border:1px solid #e0e0e0">10
       </td></tr>
       
       <tr style="border-bottom:1px solid #ccc">
       <td style="padding:8px; border:1px solid #e0e0e0">திங்
       </td>
       <td style="padding:8px; border:1px solid #e0e0e0">22
       </td>
       <td style="padding:8px; border:1px solid #e0e0e0">06
       </td></tr>
       <tr style="border-bottom:1px solid #ccc">
       <td style="padding:8px; border:1px solid #e0e0e0">செவ்
       </td>
       <td style="padding:8px; border:1px solid #e0e0e0">18
       </td>
       <td style="padding:8px; border:1px solid #e0e0e0">02
       </td></tr>
       <tr style="border-bottom:1px solid #ccc">
       <td style="padding:8px; border:1px solid #e0e0e0">புத
       </td>
       <td style="padding:8px; border:1px solid #e0e0e0">14
       </td>
       <td style="padding:8px; border:1px solid #e0e0e0">26
       </td></tr>
       <tr style="border-bottom:1px solid #ccc">
       <td style="padding:8px; border:1px solid #e0e0e0">வியா
       </td>
       <td style="padding:8px; border:1px solid #e0e0e0">10
       </td>
       <td style="padding:8px; border:1px solid #e0e0e0">22
       </td></tr>
       <tr style="border-bottom:1px solid #ccc">
       <td style="padding:8px; border:1px solid #e0e0e0">வெள்
       </td>
       <td style="padding:8px; border:1px solid #e0e0e0">06
       </td>
       <td style="padding:8px; border:1px solid #e0e0e0">18
       </td></tr>
       <tr style="border-bottom:1px solid #ccc">
       <td style="padding:8px; border:1px solid #e0e0e0">சனி
       </td>
       <td style="padding:8px; border:1px solid #e0e0e0">02
       </td>
       <td style="padding:8px; border:1px solid #e0e0e0">14
       </td></tr>
       
      
  
  
  
      
          </div>  
          </details><details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
          <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">5. சஷ்டாஷ்டம அந்திய இந்து </div>         </summary>
    <div class="mydiv">
               
      
  முஹூர்த்த லக்னத்திற்கு 6 - 8 - 12ல் சந்திரன் இருக்கக்கூடிய காலம் முஹூர்த்தத்திற்கு ஆகாத காலம்.
      
          </div>
    </details><details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
          <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">6. அஸத் த்ருஷ்டம்  </div>         </summary>
    <div class="mydiv">
               
      அஸத் த்ருஷ்டம் என்றால் பாபகிரக பார்வை என்று பொருள்.<br>
  முஹூர்த்தம் வைத்துள்ள நேரததிற்கு உரிய லக்னத்தைப் பாபக்கிரஹங்களாகிய சூரியன், செவ்வாய், சனி, ராகு, கேது ஆகியோர் பார்வை கூடாது. அவ்வாறு பாபக் கிரஹங்கள் பார்வை உள்ள லக்னத்தில் முஹூர்த்தம் வைக்கக்கூடாது.
  
      
          </div>
    
    </details><details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
          <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">7. அஸத் ஆரூடம்  </div>         </summary>
    <div class="mydiv"> 
              
  
அஸத் ஆரூடம் என்றால் பாபி நின்ற ராசி என்று பொருள்.<br> 
  
  முஹூர்த்த லக்னத்தில் பாபகிரஹங்கள் எதுவும் இருக்கக்கூடாது. 
  
          </div>  
          </details><details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
          <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">8. அஸத் விமுக்தம்  </div>         </summary>
    <div class="mydiv">
      அஸத் விமுக்தம் என்றால் பாபி விட்ட ராசி என்று பொருள். 
      அதாவது பாபக்ரஹம் இந்த ராசியிலிருந்து அடுத்த ராசிக்குச் சென்றுவிட்டது என அறிக.
      <br>
      
  சூரியன், செவ்வாய், சனி, ராகு, கேது ஆகிய பாபங்கிரஹங்கள் ஒரு லக்னத்தில் இருந்து அடுத்த ராசிக்கு பெயர்ந்து சென்றுள்ள நிலையில் அந்த லக்னத்திலும் முஹூர்த்தம் வைக்கக் கூடாது.
  உதாரணம் - ரிஷபத்திலிருந்து சனி பெயர்ந்து மிதுனத்தில் உள்ள வரை ரிஷபம் பாபி விட்ட ராசியாகும் அதனால் அதில் முஹூர்த்தம் வைக்கக்கூடாது. அல்லது பாபக்கிரஹம் லக்னத்திற்கு 2ம் வீட்டில் இல்லாமல் பார்த்துக்கொள்ளவேண்டும்.
  ஆனால் அதுவே 2ம் இடத்தில் சந்திரன் இருந்தால் இந்த தோஷம் நிவர்தியாகும்.
      
          </div>
    </details><details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
          <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">9. சித திருக்  </div>         </summary>
    <div class="mydiv">
               
              சித த்ருக் என்றால் சுக்கிரன் பார்வை பெற்ற ராசி எனப்பொருள். 
  முஹூர்த்த லக்னத்தைச் சுக்கிரன் பார்கக்கூடாது. அவ்வாறு சுக்கிரன் பார்க்கும் ராசியை முஹூர்த்த லக்னமாக அமைப்பது தோஷமாகும். ஆனால் நிஷேக (சாந்தி முஹூர்த்த) லக்னத்திற்கு இந்த விதி பொருந்தாது.
  
      
          </div>
  
    </details><details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
          <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">10. ஸந்தியா காலம் </div>         </summary>
    <div class="mydiv"> 
              
      
  சூரிய உதயத்திற்கு முன் (48 நிமிடம்) இரண்டு நாழியும், சூரிய அஸ்தமனத்திற்கு பின் இரண்டு நாழியும் ஸந்தியா காலம் ஆகும். இந்த நேரததில் முஹூர்த்தம் வைக்கக்கூடாது.
  
  
      
          </div>  
          </details><details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
          <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">11. கண்டாந்தம் </div>         </summary>
    <div class="mydiv">
               
  
  
  
  அஸ்வினி, மகம், மூலம் ஆகிய நக்ஷத்திரங்களின் முதல் பாதமும் ஆயில்யம், கேட்டை, ரேவதி ஆகிய நக்ஷத்திரங்களின் நான்காம் பாதமும் கண்டாந்தமாகும். இதில் முஹூர்த்தம் வைக்கக்கூடாது.
  
      
          </div>
    </details><details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
          <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">12. உஷ்ணம் </div>         </summary>
    <div class="mydiv">
               
      
  நக்ஷத்திரங்கள் தொடங்கி முடிவதற்குள் அதில் குறிப்பிட்ட காலம் உஷ்ணம் என்கிற தோஷம் ஏற்படுகிறது. அந்த உஷ்ண காலத்தில் முஹூர்த்தம் வைக்காமல் தவிர்ப்பது நல்லது. கீழ்க்கண்ட பட்டியல் படி உஷ்ணகாலத்தை அறியவும்.
  <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">நக்ஷத்ரம்</td><td style="padding:8px; border:1px solid #e0e0e0">		நாழி</td><td style="padding:8px; border:1px solid #e0e0e0">நாழி-வரை </td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">அஸ், ரோகி, புனர், மகம், ஹஸ் </td><td style="padding:8px; border:1px solid #e0e0e0">07.30</td><td style="padding:8px; border:1px solid #e0e0e0">15.00</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">பர, மிருக, பூச, பூர, சித்தி</td><td style="padding:8px; border:1px solid #e0e0e0">55.00</td><td style="padding:8px; border:1px solid #e0e0e0">60.00</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">க்ரு, திருவா, ஆயி, உத்ர, ஸ்வா </td><td style="padding:8px; border:1px solid #e0e0e0">21.00</td><td style="padding:8px; border:1px solid #e0e0e0">30.00</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">விசா, மூல, திருவோ, பூரட்</td><td style="padding:8px; border:1px solid #e0e0e0">00.00</td><td style="padding:8px; border:1px solid #e0e0e0">06.00</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">அநு, பூராட, அவி, உத்ரட்</td><td style="padding:8px; border:1px solid #e0e0e0">52.00</td><td style="padding:8px; border:1px solid #e0e0e0">60.00</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">கேட், உத்ரா, சதய, ரேவதி</td><td style="padding:8px; border:1px solid #e0e0e0">20.00	</td><td style="padding:8px; border:1px solid #e0e0e0">30.00</td></tr></table>
  
      
          </div>
  
    </details><details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
          <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">13. விஷம் </div>         </summary>
    <div class="mydiv"> 
              
      
  த்யாஜ்ய காலமே விஷம் என்று சொல்லப்படும். 
  திதி, நக்ஷத்திரம் போன்றவை தொடங்கிய காலத்திலிருந்து ஒரு குறிப்பிட்ட நாழிகைக்கு மேல் 4 நாழிகை வரை த்யாஜ்ய காலம் ஆகும்.
  ஒரு திதி தொடங்கும் காலம் என்பது முந்தைய திதி முடிவடையும் நேரம் அடுத்த திதி தொடங்கும் நேரம் ஆகும். அதுபோல் நக்ஷத்திரம் போன்ற மற்றவை தொடங்கும் நேரம் அறியவும்.
  <hr>
  <h2 class="head2">திதி த்யாஜ்யம் </h2>
  <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
  
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">ப்ரதமை</td><td style="padding:8px; border:1px solid #e0e0e0">24</td><td style="padding:8px; border:1px solid #e0e0e0">28</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">துவிதியை</td><td style="padding:8px; border:1px solid #e0e0e0">12</td><td style="padding:8px; border:1px solid #e0e0e0">16</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">த்ருதியை</td><td style="padding:8px; border:1px solid #e0e0e0">55</td><td style="padding:8px; border:1px solid #e0e0e0">59</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">சதுர், நவமி</td><td style="padding:8px; border:1px solid #e0e0e0">05</td><td style="padding:8px; border:1px solid #e0e0e0">09</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">பஞ்ச, ஷஷ்டி</td><td style="padding:8px; border:1px solid #e0e0e0">54</td><td style="padding:8px; border:1px solid #e0e0e0">58</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">ஸப்தமி</td><td style="padding:8px; border:1px solid #e0e0e0">31</td><td style="padding:8px; border:1px solid #e0e0e0">35</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">அஷ்டமி</td><td style="padding:8px; border:1px solid #e0e0e0">20</td><td style="padding:8px; border:1px solid #e0e0e0">24</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">தசமி</td><td style="padding:8px; border:1px solid #e0e0e0">33</td><td style="padding:8px; border:1px solid #e0e0e0">37</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">ஏகாதசி</td><td style="padding:8px; border:1px solid #e0e0e0">01</td><td style="padding:8px; border:1px solid #e0e0e0">05</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">துவாதசி</td><td style="padding:8px; border:1px solid #e0e0e0">15</td><td style="padding:8px; border:1px solid #e0e0e0">19</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">த்ரயோதசி</td><td style="padding:8px; border:1px solid #e0e0e0">26</td><td style="padding:8px; border:1px solid #e0e0e0">30</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">சதுர்தசி</td><td style="padding:8px; border:1px solid #e0e0e0">07</td><td style="padding:8px; border:1px solid #e0e0e0">11</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">பௌர்ணமி</td><td style="padding:8px; border:1px solid #e0e0e0">29</td><td style="padding:8px; border:1px solid #e0e0e0">33</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">அமாவாசை</td><td style="padding:8px; border:1px solid #e0e0e0">06</td><td style="padding:8px; border:1px solid #e0e0e0">10</td></tr>
  </table>
  <h2 class="head2">வாரத் த்யாஜ்யம்</h2>
  <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">ஞாயிறு</td><td style="padding:8px; border:1px solid #e0e0e0">32</td><td style="padding:8px; border:1px solid #e0e0e0">36</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">திங்கள், புதன்</td><td style="padding:8px; border:1px solid #e0e0e0">42</td><td style="padding:8px; border:1px solid #e0e0e0">46</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">செவ்வா</td><td style="padding:8px; border:1px solid #e0e0e0">31</td><td style="padding:8px; border:1px solid #e0e0e0">35</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">வியாழ</td><td style="padding:8px; border:1px solid #e0e0e0">31</td><td style="padding:8px; border:1px solid #e0e0e0">35</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">வெள்ளி</td><td style="padding:8px; border:1px solid #e0e0e0">21</td><td style="padding:8px; border:1px solid #e0e0e0">25</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">சனி</td><td style="padding:8px; border:1px solid #e0e0e0">14</td><td style="padding:8px; border:1px solid #e0e0e0">18</td></tr>
  </table>
  
  <h2 class="head2">நக்ஷத்திரத் த்யாஜ்யம்</h2>
  <table style="width:100%; border-collapse:collapse; margin-bottom:15px; background:#fffef0">
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">அஸ்வினி</td><td style="padding:8px; border:1px solid #e0e0e0">50</td><td style="padding:8px; border:1px solid #e0e0e0">54</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">பரணி	</td><td style="padding:8px; border:1px solid #e0e0e0">24</td><td style="padding:8px; border:1px solid #e0e0e0">28</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">கார்த்திகை</td><td style="padding:8px; border:1px solid #e0e0e0">30</td><td style="padding:8px; border:1px solid #e0e0e0">34</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">ரோகிணி</td><td style="padding:8px; border:1px solid #e0e0e0">40</td><td style="padding:8px; border:1px solid #e0e0e0">44</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">மிருகசீர்ஷம்</td><td style="padding:8px; border:1px solid #e0e0e0">14</td><td style="padding:8px; border:1px solid #e0e0e0">18</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">திருவாதிரை</td><td style="padding:8px; border:1px solid #e0e0e0">21</td><td style="padding:8px; border:1px solid #e0e0e0">25</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">புனர்பூசம்</td><td style="padding:8px; border:1px solid #e0e0e0">30</td><td style="padding:8px; border:1px solid #e0e0e0">34</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">பூசம்	</td><td style="padding:8px; border:1px solid #e0e0e0">20</td><td style="padding:8px; border:1px solid #e0e0e0">24</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">ஆயில்யம்</td><td style="padding:8px; border:1px solid #e0e0e0">32</td><td style="padding:8px; border:1px solid #e0e0e0">36</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">மகம்</td><td style="padding:8px; border:1px solid #e0e0e0">30</td><td style="padding:8px; border:1px solid #e0e0e0">34</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">பூரம்	</td><td style="padding:8px; border:1px solid #e0e0e0">20</td><td style="padding:8px; border:1px solid #e0e0e0">24</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">உத்ரம்	</td><td style="padding:8px; border:1px solid #e0e0e0">18</td><td style="padding:8px; border:1px solid #e0e0e0">22</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">ஹஸ்தம்</td><td style="padding:8px; border:1px solid #e0e0e0">21</td><td style="padding:8px; border:1px solid #e0e0e0">25</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">சித்திரை</td><td style="padding:8px; border:1px solid #e0e0e0">20</td><td style="padding:8px; border:1px solid #e0e0e0">24</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">ஸ்வாதி	</td><td style="padding:8px; border:1px solid #e0e0e0">14</td><td style="padding:8px; border:1px solid #e0e0e0">18</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">விசாகம்</td><td style="padding:8px; border:1px solid #e0e0e0">14</td><td style="padding:8px; border:1px solid #e0e0e0">18</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">அநுஷம்</td><td style="padding:8px; border:1px solid #e0e0e0">10</td><td style="padding:8px; border:1px solid #e0e0e0">14</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">கேட்டை</td><td style="padding:8px; border:1px solid #e0e0e0">14</td><td style="padding:8px; border:1px solid #e0e0e0">18</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">மூலம்</td><td style="padding:8px; border:1px solid #e0e0e0">56</td><td style="padding:8px; border:1px solid #e0e0e0">60</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">பூராடம்	</td><td style="padding:8px; border:1px solid #e0e0e0">24</td><td style="padding:8px; border:1px solid #e0e0e0">28</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">உத்ராடம்</td><td style="padding:8px; border:1px solid #e0e0e0">20</td><td style="padding:8px; border:1px solid #e0e0e0">24</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">திருவோணம்</td><td style="padding:8px; border:1px solid #e0e0e0">10</td><td style="padding:8px; border:1px solid #e0e0e0">14</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">அவிட்டம்</td><td style="padding:8px; border:1px solid #e0e0e0">10</td><td style="padding:8px; border:1px solid #e0e0e0">14</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">சதயம்	</td><td style="padding:8px; border:1px solid #e0e0e0">18</td><td style="padding:8px; border:1px solid #e0e0e0">22</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">பூரட்டாதி</td><td style="padding:8px; border:1px solid #e0e0e0">16</td><td style="padding:8px; border:1px solid #e0e0e0">20</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">உத்ரட்டாதி</td><td style="padding:8px; border:1px solid #e0e0e0">24</td><td style="padding:8px; border:1px solid #e0e0e0">28</td></tr>
  <tr style="border-bottom:1px solid #ccc"><td style="padding:8px; border:1px solid #e0e0e0">ரேவதி	</td><td style="padding:8px; border:1px solid #e0e0e0">30</td><td style="padding:8px; border:1px solid #e0e0e0">34</td></tr>
  </table>
  
  <h2 class="head2">லக்ன த்யாஜ்யம் </h2>
  
  மேஷ, ரிஷ, கன், தனு - ஆரம்பித்தது முதல் முக்கால் நாழி <hr>
  மிது, சிம், துலா, கும் - நடுவில் முக்கால் நாழிகை<hr>
  கட, விரு, மகர, மீன - முடிவில் முக்கால் நாழிகை <hr>
  
  
      
          </div>  
          </details><details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
          <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">14. ஸ்திர கரணம் </div>         </summary>
    <div class="mydiv">
               
      
  (அ) சகுனி (ஆ) சதுஷ்பாதம் (இ) நாகவம் (ஈ) கிம்ஸ்துக்னம்
  ஆகிய நான்கும் ஸ்திர கரணங்களாகும் இவை சுப காரியங்கள் செய்ய உகந்தவையல்ல.
  
      
          </div>
    </details><details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
          <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">15. ரிக்தை அல்லது இருத்தை </div>         </summary>
    <div class="mydiv">
               
     
  (அ) சதுர்த்தி (ஆ) நவமி (இ) சதுர்த்தசி
  இவை மூன்றும் இருத்தை எனப்படும். இவற்றில் சுப காரியங்கள் செய்யக்கூடாது.
      
          </div>
  
    </details><details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
          <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">16. அஷ்டமி </div>         </summary>
    <div class="mydiv"> 
              
      
  அஷ்டமி திதி சுப காரியங்களுக்கு ஏற்றதல்ல எனினும் தேய்பிறை அஷ்டமி சுப காரியங்களுக்கு உகந்தது என்று சில சாஸ்திர நூல்கள் சொல்கின்றன.
  
  
      
          </div>  
          </details><details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
          <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">17. லாடம் </div>         </summary>
    <div class="mydiv">
               
      
  சூரியன் நின்ற நக்ஷத்திரத்திலிருந்து மூலம் நக்ஷத்திரம் வரை எண்ண வேண்டும். அவ்வாறு எண்ணி வந்த தொகையைப் பூராடம் முதல் எண்ணினால் கிடைக்கும் நக்ஷத்திரம் எதுவோ அதுவே லாட நக்ஷத்திரம் ஆகும். இதில் சுபகாரியங்கள் செய்யக் கூடாது.
  சூரியன் நின்ற நக்ஷத்திரம் அஸ்வினி என்றால் - அஸ்வினியிலிருந்து மூலம் வரை எண்ண 19 கிடைக்கும். பூராடத்திலிருந்து 19 வது நக்ஷத்திரம் பூரம் ஆகும் - இதுவே லாட நக்ஷத்திரமாகும்.
  
      
          </div>
    </details><details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
          <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">18. ஏகார்க்களம் </div>         </summary>
    <div class="mydiv">
               
      
  அன்றைய சூர்ய ஸ்புடத்தை 360 டிகிரியிலிந்து கழித்து வரும் ஸ்புடத்திற்கு உரிய நக்ஷத்திரத்தைக் காணவேண்டும். அவ்வாறு கணக்கிட்டு வரும் நக்ஷத்திரத்திலிருந்து 1 - 2 - 7 - 10 - 11 - 14 - 16 - 18 - 20 ஆகிய நக்ஷத்திரங்கள் ஏகார்கள நக்ஷத்திரங்களாகும்.
  
      
          </div>
  
    </details><details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
          <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">19. வைதிருதம் </div>         </summary>
    <div class="mydiv"> 
              
      
  சூரியன் நின்ற நக்ஷத்திரத்திற்கு 14வது நக்ஷத்திரம் வைதிருதம் ஆகும். இதுவும் முஹூர்த்தத்திற்கு விலக்கப்படவேண்டிய நக்ஷத்திரமாகும்.
  
  
      
          </div>  
          </details><details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
          <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">20. அஹிசிரசு </div>         </summary>
    <div class="mydiv">
               
      
  வ்யதீபாத யோகத்தின் பிற்பகுதி அஹிசிரசு எனப்படும். இதுவும் முஹூர்த்தத்திற்கு விலக்கப்படவேண்டியதாகும்.
  வ்யதீபாத யோகத்தின் ஆத்யந்த நாழிகையைக் கணக்கிட்டு அதனை இரண்டால் வகுத்க வேண்டும். அதனை சித்தி யோகத்தின் முடிவு நாழிகையுடன் கூட்டவேண்டும். அவ்வாறு கூட்டி வரும் நாழிகையிலிருந்து வ்யதீபாத யோகத்தின் முடிவு நாழிகை வரை உள்ள காலம் அஹிசிரசாகும்.
  
      
          </div>
    </details><details style="margin-bottom:10px; background:#fff; border-radius:8px; padding:10px; border:1px solid #c8e6c9">
          <summary style="font-weight:bold; cursor:pointer; color:#1b5e20; font-size:1.1rem; border-bottom:1px solid orange; padding-bottom:5px; margin-bottom:10px;"><div class="head3">21. விஷ்டி </div>         </summary>
    <div class="mydiv">
               
    
  வளர்பிறை
  அஷ்டமி, ஏகாதசியில் 6 முதல் 12 நாழிகை வரையிலும், பௌர்ணமியில் 18 முதல் 24 நாழிகை வரையிலும் சதுர்த்தசியில் 24 முதல் 30 நாழிகை வரையிலும்.
  தேய்பிறை
  த்ருதியையில் 30 முதல் 36 நாழிகை வரையிலும், ஸப்தமியில் 12 முதல் 18 நாழிகை வரையிலும், தசமியில் 42 முதல்  48 நாழிகை வரையிலும், சதுர்தசியில் முதல் 6 நாழிகை வரையிலும் விஷ்டி ஆகும். எனவே இந்த நேரங்களில் முஹூர்த்தம் வைப்பதை தவிர்க்கவேண்டும்.
  
  
      
          </div> 
  </details>
</div>
<div class="color4">
  <div class="div3">இவை தவிர அம்ஹஸ்பதி, மலமாதம், ஸமஸர்ப்பம், திர்சியதாஹி குருசிதயோஹோ, குரு, சுக்கிர மௌட்டியம், குரு சுக்கிர மித்ர த்ருஷ்டி போன்ற மேலும் பல தோஷங்களும் உள்ளன.
  </div></div>

` }} />
    </div>
  );
};

export default DayDhoshaPage;
